export class Constants {
  // Place a local url when demo testing

  //static urlLocal: string = "http://192.168.100.14:8000/codagence_apis";
  //static urlLocal: string = "http://127.0.0.1:8000/caramel_analytic_apis";
  static urlLocal: string = "";

  // Url cloud is for production
  static urlCloud: string = " https://codagence-dev.herokuapp.com/codagence_apis";
  static apiver: string = "v1";
  static appver: string = "1.0";
}
